export function staticMapUrl(geo, width = 160, height = 80, placeholder = 'https://via.placeholder.com/160x80?text=Map') {
    if (!geo) {
        return placeholder;
    }
    const latLng = geo.match(/-?\d+\.?\d*/gm);
    if (latLng && latLng.length === 2) {
        return `https://maps.googleapis.com/maps/api/staticmap?center=${latLng[1]},${latLng[0]}&zoom=16&maptype=satellite&scale=2&size=${width * 2}x${height * 2}&key=AIzaSyAeN5-IYlesnHYrLOnG0PHGmlAR6M-Bfbw`;
    }
    return placeholder;
}
export function checkLatLng(geo = '') {
    if (!geo) {
        return false;
    }
    try {
        if (!/(-?\d+.?\d*[SNsn]?)[\s,]+(-?\d+.?\d*[WEwe]?\s*?$)/.test(geo)) {
            return false;
        }
        const latLng = geo.match(/-?\d+\.?\d*/gm);
        if (!latLng || latLng.length !== 2)
            return false;
        const lat = parseFloat(latLng[0]);
        const lng = parseFloat(latLng[1]);
        return Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
    }
    catch (e) {
        console.log(e);
        return false;
    }
}
export function formatLatLng(geo, placeholder = '') {
    if (!geo) {
        return placeholder;
    }
    let checkSouth = false;
    try {
        checkSouth = geo.split(',')[0].indexOf('S') > -1;
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
    let checkWest = false;
    try {
        checkWest = geo.split(',')[1].indexOf('W') > -1;
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
    const latLng = geo.match(/-?\d+\.?\d*/gm);
    if (latLng && latLng.length === 2) {
        const lat = parseFloat(latLng[1]);
        const lng = parseFloat(latLng[0]);
        let NS = '';
        if (Math.abs(lat) === lat) {
            NS = checkSouth ? 'S' : 'N';
        }
        else {
            NS = lat < 0 ? 'S' : 'N';
        }
        let EW = '';
        if (Math.abs(lng) === lng) {
            EW = checkWest ? 'W' : 'E';
        }
        else {
            EW = lng < 0 ? 'W' : 'E';
        }
        return `${Math.abs(lat).toFixed(4)}${NS}, ${Math.abs(lng).toFixed(4)}${EW}`;
    }
    return placeholder;
}
export function getGoogleMapsLink(geo) {
    return `http://maps.google.com/maps?basemap=satellite&q=${formatLatLng(geo)}`;
}
export function covertLatLngToGeometry(geo) {
    if (geo) {
        const latLng = geo.match(/-?\d+\.?\d*[NSEW]?/gim);
        if (latLng && latLng.length === 2) {
            const latStr = latLng[0];
            const lngStr = latLng[1];
            let lat;
            let lng;
            if (latStr.toLowerCase().indexOf('n') > 0) {
                lat = parseFloat(latStr.slice(0, -1));
            }
            else if (latStr.toLowerCase().indexOf('s') > 0) {
                lat = -parseFloat(latStr.slice(0, -1));
            }
            else {
                lat = parseFloat(latStr);
            }
            if (lngStr.toLowerCase().indexOf('e') > 0) {
                lng = parseFloat(lngStr.slice(0, -1));
            }
            else if (lngStr.toLowerCase().indexOf('w') > 0) {
                lng = -parseFloat(lngStr.slice(0, -1));
            }
            else {
                lng = parseFloat(lngStr);
            }
            return `POINT(${lng} ${lat})`;
        }
    }
    return null;
}
